import RemoveWarehouseReleaseModal from './RemoveWarehouseReleaseModal';
export default RemoveWarehouseReleaseModal;
